import { Component, OnInit } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { FormGroup } from "@angular/forms";
import {
  DataService,
  CustomDetailComponent,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { ShipmentStatusByOrderIdDocument } from "../generated-graphql/graphql";

@Component({
  template: `<vdr-card [title]="'order.shipment-status-info' | translate">
    <pre>{{ extraInfo$ | async | json }}</pre>
  </vdr-card>`,
  standalone: true,
  imports: [SharedModule],
})
export class ShipmentStatusInfoComponent
  implements CustomDetailComponent, OnInit
{
  // These two properties are provided by Vendure and will vary
  // depending on the particular detail page you are embedding this
  // component into. In this case, it will be a "product" entity.
  entity$: Observable<any>;
  detailForm: FormGroup;

  extraInfo$: Observable<any>;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.extraInfo$ = this.entity$.pipe(
      switchMap((entity) =>
        this.dataService
          .query(ShipmentStatusByOrderIdDocument, { id: entity.id })
          .mapSingle((item) => item.shipmentStatusByOrderId?.data)
      )
    );
    //console.log(this.extraInfo$);
  }
}
